(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3917],{

/***/ 72365:
/***/ (function(module) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"recentBatchesFromLine"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lineId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BatchFilter"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lineId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lineId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"batches"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"batchId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"batchNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"actualStart"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"actualStop"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":239}}');
    doc.loc.source = JSON.parse('{"body":"query recentBatchesFromLine($lineId: ID!, $filter: BatchFilter) {\\n  line(lineId: $lineId) {\\n    id\\n    batches(filter: $filter) {\\n      items {\\n        batchId\\n        batchNumber\\n        actualStart\\n        actualStop\\n      }\\n    }\\n  }\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports.recentBatchesFromLine = oneQuery(doc, "recentBatchesFromLine");
        


/***/ }),

/***/ 59964:
/***/ (function(module) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"shiftTimes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lineId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"validIn"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ScheduleTimeInput"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lineId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lineId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"schedule"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"validIn"},"value":{"kind":"Variable","name":{"kind":"Name","value":"validIn"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"shifts"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"timeRange"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"day"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hour"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"minute"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"to"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"day"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hour"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"minute"},"arguments":[],"directives":[]}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"configuration"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timezone"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"startDayOfWeek"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":459}}');
    doc.loc.source = JSON.parse('{"body":"query shiftTimes($lineId: ID!, $validIn: ScheduleTimeInput!) {\\n  line(lineId: $lineId) {\\n    id\\n    schedule(validIn: $validIn) {\\n      id\\n      shifts {\\n        id\\n        name\\n        timeRange {\\n          from {\\n            day\\n            hour\\n            minute\\n          }\\n          to {\\n            day\\n            hour\\n            minute\\n          }\\n        }\\n      }\\n\\n      configuration {\\n        timezone\\n        startDayOfWeek\\n      }\\n    }\\n  }\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports.shiftTimes = oneQuery(doc, "shiftTimes");
        


/***/ }),

/***/ 15169:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4656);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86533);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(59106);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78391);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var _mui_material_SnackbarContent__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(95280);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29901);
/* harmony import */ var recompose__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14895);
/* harmony import */ var _hocs_with_styles__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5887);










var styles = function(_theme) {
    return {
        snackbar: function(props) {
            return {
                // backgroundColor: props.backgroundColor ? props.backgroundColor : amber[700],
                maxWidth: "100%",
                marginBottom: "1em"
            };
        }
    };
};
var WideSnackBar = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(WideSnackBar, _Component);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(WideSnackBar);
    function WideSnackBar() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, WideSnackBar);
        return _super.apply(this, arguments);
    }
    var _proto = WideSnackBar.prototype;
    _proto.render = function render() {
        var _props = this.props, classes = _props.classes, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_props, [
            "classes"
        ]);
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_SnackbarContent__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
            className: classes.snackbar
        }, rest));
    };
    return WideSnackBar;
}(react__WEBPACK_IMPORTED_MODULE_1__.Component);
var enhance = (0,recompose__WEBPACK_IMPORTED_MODULE_2__/* .compose */ .qC)((0,_hocs_with_styles__WEBPACK_IMPORTED_MODULE_9__/* .withStyles */ .D)(styles, {
    withTheme: true
}));
/* harmony default export */ __webpack_exports__["Z"] = (enhance(WideSnackBar));


/***/ }),

/***/ 32476:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4656);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86533);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78391);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var _mui_material_Icon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(48671);
/* harmony import */ var _mui_material_IconButton__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10016);
/* harmony import */ var _mui_material_Typography__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(94941);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29901);
/* harmony import */ var recompose__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14895);
/* harmony import */ var _hocs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(81861);
/* harmony import */ var _hocs_with_styles__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5887);











var styles = function(theme) {
    return {
        switchHeader: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: theme.spacing()
        },
        daysHeader: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        },
        dayLabel: {
            width: 36,
            margin: "0 2px",
            textAlign: "center",
            color: theme.palette.text.secondary
        }
    };
};
var _PureComponent;
var CalendarHeader = /*#__PURE__*/ function(_superClass) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(CalendarHeader, _superClass);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(CalendarHeader);
    function CalendarHeader() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, CalendarHeader);
        return _super.apply(this, arguments);
    }
    var _proto = CalendarHeader.prototype;
    _proto.render = function render() {
        var _props = this.props, classes = _props.classes, theme = _props.theme, currentMonth = _props.currentMonth, onNextMonth = _props.onNextMonth, onPreviousMonth = _props.onPreviousMonth, leftArrowIcon = _props.leftArrowIcon, rightArrowIcon = _props.rightArrowIcon, disablePrevMonth = _props.disablePrevMonth, disableNextMonth = _props.disableNextMonth, utils = _props.utils;
        var rtl = theme.direction === "rtl";
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: classes.switchHeader,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_IconButton__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            disabled: disablePrevMonth,
                            onClick: onPreviousMonth,
                            size: "large",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Icon__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                children: rtl ? rightArrowIcon : leftArrowIcon
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            variant: "body2",
                            children: utils.formatByString(currentMonth, "LLLL yyyy")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_IconButton__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            disabled: disableNextMonth,
                            onClick: onNextMonth,
                            size: "large",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Icon__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                children: rtl ? leftArrowIcon : rightArrowIcon
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: classes.daysHeader,
                    children: utils.getWeekdays().map(function(day, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            variant: "caption",
                            className: classes.dayLabel,
                            children: day
                        }, index);
                    })
                })
            ]
        });
    };
    return CalendarHeader;
}(_PureComponent = react__WEBPACK_IMPORTED_MODULE_1__.PureComponent);
CalendarHeader.defaultProps = {
    leftArrowIcon: "keyboard_arrow_left",
    rightArrowIcon: "keyboard_arrow_right",
    disablePrevMonth: false,
    disableNextMonth: false
};
var enhance = (0,recompose__WEBPACK_IMPORTED_MODULE_2__/* .compose */ .qC)(_hocs__WEBPACK_IMPORTED_MODULE_9__/* .withUtils */ .W, (0,_hocs_with_styles__WEBPACK_IMPORTED_MODULE_10__/* .withStyles */ .D)(styles, {
    withTheme: true,
    name: "MuiPickersCalendarHeader"
}));
/* harmony default export */ __webpack_exports__["Z"] = (enhance(CalendarHeader));


/***/ }),

/***/ 47864:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ date_time_picker; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(4656);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(86533);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_create_super.mjs + 3 modules
var _create_super = __webpack_require__(78391);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61250);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@apollo+client@3.4.0-rc.0_graphql@16.6.0_react@17.0.2/node_modules/@apollo/client/react/components/Query.js
var Query = __webpack_require__(54524);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.11.16_@types+react@17.0.53_react@17.0.2/node_modules/@mui/icons-material/ArrowBack.js
var ArrowBack = __webpack_require__(22688);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.11.16_@types+react@17.0.53_react@17.0.2/node_modules/@mui/icons-material/ArrowForward.js
var ArrowForward = __webpack_require__(20435);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.11.16_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.53_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Box/Box.js
var Box = __webpack_require__(36451);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.11.16_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.53_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Button/Button.js
var Button = __webpack_require__(14834);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.11.16_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.53_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Card/Card.js
var Card = __webpack_require__(2716);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.11.16_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.53_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/CardActions/CardActions.js
var CardActions = __webpack_require__(43635);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.11.16_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.53_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/CardContent/CardContent.js
var CardContent = __webpack_require__(58797);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.11.16_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.53_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Divider/Divider.js
var Divider = __webpack_require__(71867);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.11.16_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.53_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Modal/Modal.js + 1 modules
var Modal = __webpack_require__(97406);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.11.16_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.53_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Popover/Popover.js
var Popover = __webpack_require__(4134);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.11.16_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.53_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Tab/Tab.js
var Tab = __webpack_require__(71077);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.11.16_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.53_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Tabs/Tabs.js + 3 modules
var Tabs = __webpack_require__(53006);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.11.16_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.53_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Typography/Typography.js
var Typography = __webpack_require__(94941);
// EXTERNAL MODULE: ../generated/graphql/schema.ts
var schema = __webpack_require__(25955);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(29901);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-i18next@11.18.6_i18next@21.10.0_react-dom@17.0.2_react@17.0.2/node_modules/react-i18next/dist/es/withTranslation.js
var withTranslation = __webpack_require__(89928);
// EXTERNAL MODULE: ../../node_modules/.pnpm/recompose@0.30.0_react@17.0.2/node_modules/recompose/dist/Recompose.esm.js + 2 modules
var Recompose_esm = __webpack_require__(14895);
// EXTERNAL MODULE: ./components/bars/wide-snackbar.tsx
var wide_snackbar = __webpack_require__(15169);
// EXTERNAL MODULE: ./components/loading/loading-or-error.tsx
var loading_or_error = __webpack_require__(89879);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(88149);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.11.16_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.53_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/TextField/TextField.js
var TextField = __webpack_require__(56174);
// EXTERNAL MODULE: ./components/pickers/date-time-range-picker/day-wrapper.tsx
var day_wrapper = __webpack_require__(19101);
// EXTERNAL MODULE: ./components/pickers/date-time-range-picker/day.tsx
var date_time_range_picker_day = __webpack_require__(81013);
// EXTERNAL MODULE: ./components/pickers/date-time-range-picker/calendar-header.tsx
var calendar_header = __webpack_require__(32476);
// EXTERNAL MODULE: ./hocs/with-styles.tsx
var with_styles = __webpack_require__(5887);
// EXTERNAL MODULE: ./hocs/with-utils.tsx
var with_utils = __webpack_require__(81861);
;// CONCATENATED MODULE: ./components/pickers/date-time-range-picker/double-calendar.tsx












var styles = function(theme) {
    return {
        calendar: {
            height: 36 * 6,
            marginTop: theme.spacing(1.5)
        },
        week: {
            display: "flex",
            justifyContent: "center"
        },
        calendarWrapper: {
            display: "flex"
        },
        hour: {
            maxWidth: "7em"
        },
        minute: {
            maxWidth: "7em"
        },
        inputField: {
            fontSize: "17px",
            textAlign: "center"
        },
        timeContainer: {
            display: "flex",
            justifyContent: "space-evenly"
        },
        vr: {
            width: "1px",
            backgroundColor: "rgba(0, 0, 0, 0.12)",
            marginLeft: theme.spacing(2),
            marginRight: theme.spacing(2),
            top: "0",
            bottom: "0",
            left: "150px"
        }
    };
};
var _Component;
/* eslint-disable no-unused-expressions */ var DoubleCalendar = /*#__PURE__*/ function(_superClass) {
    "use strict";
    (0,_inherits/* default */.Z)(DoubleCalendar, _superClass);
    var _super = (0,_create_super/* default */.Z)(DoubleCalendar);
    function DoubleCalendar() {
        (0,_class_call_check/* default */.Z)(this, DoubleCalendar);
        var _this;
        _this = _super.apply(this, arguments);
        var ref;
        _this.state = {
            currentMonth: _this.props.utils.startOfMonth((ref = _this.props.utils.date()) !== null && ref !== void 0 ? ref : new Date()),
            currentState: "start",
            hoveredDay: null
        };
        _this.onDayHover = function(enter, day) {
            if (enter) {
                _this.setState({
                    hoveredDay: day
                });
            } else {
                _this.setState({
                    hoveredDay: null
                });
            }
        };
        _this.onDateSelect = function(day) {
            var _props = _this.props, startDate = _props.startDate, endDate = _props.endDate, utils = _props.utils;
            if (startDate && endDate) {
                if (utils.isAfterDay(day, utils.startOfDay(endDate)) && _this.state.currentState !== "end") {
                    // Set startdate, clear endDate and set state to 'end'
                    var withHours = utils.setHours(day, utils.getHours(startDate));
                    var withMinutes = utils.setMinutes(withHours, utils.getMinutes(startDate));
                    _this.setState({
                        currentState: "end"
                    });
                    _this.props.onChange(withMinutes, withMinutes);
                } else if (_this.state.currentState === "end" && !utils.isBeforeDay(day, utils.startOfDay(startDate))) {
                    // Set enddate and set state to 'start'
                    var withHours1 = utils.setHours(day, utils.getHours(endDate));
                    var withMinutes1 = utils.setMinutes(withHours1, utils.getMinutes(endDate));
                    _this.setState({
                        currentState: "start"
                    });
                    _this.props.onChange(startDate, withMinutes1);
                } else {
                    // Set startDate, keep endDate and set state to 'end'
                    var withHours2 = utils.setHours(day, utils.getHours(startDate));
                    var withMinutes2 = utils.setMinutes(withHours2, utils.getMinutes(startDate));
                    _this.setState({
                        currentState: "end"
                    });
                    _this.props.onChange(withMinutes2, endDate);
                }
            } else if (startDate) {
                // Set end Date
                if (utils.isBeforeDay(day, utils.startOfDay(startDate))) {
                    _this.props.onChange(day, undefined);
                } else {
                    _this.setState({
                        currentState: "start"
                    });
                    _this.props.onChange(startDate, day);
                }
            } else {
                // Set startDate
                _this.setState({
                    currentState: "end"
                });
                _this.props.onChange(day, endDate);
            }
        };
        _this.handleNextMonth = function() {
            _this.setState({
                currentMonth: _this.props.utils.getNextMonth(_this.state.currentMonth)
            });
        };
        _this.handlePreviousMonth = function() {
            _this.setState({
                currentMonth: _this.props.utils.getPreviousMonth(_this.state.currentMonth)
            });
        };
        _this.validateMinMaxDate = function(day) {
            var _props = _this.props, minDate = _props.minDate, maxDate = _props.maxDate, utils = _props.utils;
            var parsedMinDate = (0,_instanceof/* default */.Z)(minDate, Date) ? minDate : new Date(minDate !== null && minDate !== void 0 ? minDate : "");
            var parsedMaxDate = (0,_instanceof/* default */.Z)(maxDate, Date) ? maxDate : new Date(maxDate !== null && maxDate !== void 0 ? maxDate : "");
            return parsedMinDate && utils.isBeforeDay(day, parsedMinDate) || parsedMaxDate && utils.isAfterDay(day, parsedMaxDate);
        };
        _this.shouldDisablePrevMonth = function() {
            var _props = _this.props, utils = _props.utils, disablePast = _props.disablePast, minDate = _props.minDate;
            var now = new Date();
            return !utils.isBefore(utils.startOfMonth(disablePast && utils.isAfter(now, new Date(minDate !== null && minDate !== void 0 ? minDate : "")) ? now : new Date(minDate !== null && minDate !== void 0 ? minDate : "")), utils.getPreviousMonth(_this.state.currentMonth));
        };
        _this.shouldDisableNextMonth = function() {
            var _props = _this.props, utils = _props.utils, disableFuture = _props.disableFuture, maxDate = _props.maxDate;
            var now = new Date();
            return !utils.isAfter(utils.startOfMonth(disableFuture && utils.isBefore(now, new Date(maxDate !== null && maxDate !== void 0 ? maxDate : "")) ? now : new Date(maxDate !== null && maxDate !== void 0 ? maxDate : "")), _this.state.currentMonth);
        };
        _this.shouldDisableDate = function(day) {
            var _props = _this.props, disablePast = _props.disablePast, disableFuture = _props.disableFuture, shouldDisableDate = _props.shouldDisableDate, utils = _props.utils;
            return disableFuture && utils.isAfterDay(day, new Date()) || disablePast && utils.isBeforeDay(day, new Date()) || _this.validateMinMaxDate(day) || (shouldDisableDate === null || shouldDisableDate === void 0 ? void 0 : shouldDisableDate(day));
        };
        _this.moveToDay = function(day) {
            if (day && !_this.shouldDisableDate(day)) {
                _this.props.onChange(day);
            }
        };
        _this.renderWeeks = function(prev) {
            var utils = _this.props.utils;
            var currentMonth = _this.state.currentMonth;
            if (prev) {
                currentMonth = utils.getPreviousMonth(currentMonth);
            }
            var weeks = utils.getWeekArray(currentMonth);
            return weeks.map(function(week) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: _this.props.classes.week,
                    children: _this.renderDays(week, currentMonth)
                }, "week-".concat(week[0].toString()));
            });
        };
        _this.renderDays = function(week, currentMonth) {
            var _props = _this.props, startDate = _props.startDate, endDate = _props.endDate;
            var utils = _this.props.utils;
            var currentMonthNumber = utils.getMonth(currentMonth);
            var now = new Date();
            if (endDate) {
                endDate = utils.startOfDay(endDate);
            }
            if (startDate) {
                startDate = utils.startOfDay(startDate);
            }
            return week.map(function(day) {
                var disabled = _this.shouldDisableDate(day);
                var dayInCurrentMonth = utils.getMonth(day) === currentMonthNumber;
                var selected = false;
                var betweenSelected = false;
                if (endDate) {
                    selected = utils.isSameDay(endDate, day);
                }
                if (startDate && !selected) {
                    selected = utils.isSameDay(startDate, day);
                }
                if (startDate && endDate) {
                    betweenSelected = utils.isBeforeDay(day, endDate) && utils.isAfterDay(day, startDate);
                }
                if (_this.state.hoveredDay && !endDate) {
                    betweenSelected = utils.isAfterDay(day, utils.startOfDay(startDate)) && utils.isBeforeDay(day, utils.startOfDay(_this.state.hoveredDay));
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(day_wrapper/* default */.Z, {
                    value: day,
                    dayInCurrentMonth: dayInCurrentMonth,
                    disabled: disabled,
                    onSelect: _this.onDateSelect,
                    onMouseEnter: _this.handleOnMouse(disabled, dayInCurrentMonth, day, true),
                    onMouseLeave: _this.handleOnMouse(disabled, dayInCurrentMonth, day, false),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(date_time_range_picker_day/* default */.Z, {
                        current: utils.isSameDay(day, now),
                        hidden: !dayInCurrentMonth,
                        disabled: disabled,
                        selected: selected,
                        betweenSelected: betweenSelected,
                        children: utils.formatByString(day, "d")
                    })
                }, day.toString());
            });
        };
        _this.handleOnMouse = function(disabled, dayInCurrentMonth, day, enter) {
            return function() {
                if (!disabled && dayInCurrentMonth) {
                    _this.onDayHover(enter, day);
                }
            };
        };
        _this.onChangeTime = function(startEnd, hourMinutes) {
            return function(e) {
                var _props = _this.props, startDate = _props.startDate, endDate = _props.endDate;
                var utils = _this.props.utils;
                var val = Number(e.target.value);
                if (hourMinutes === "hour") {
                    // Limit hours to 0-24, with rollover
                    if (val > 23) {
                        val = 0;
                    } else if (val < 0) {
                        val = 23;
                    }
                    if (startEnd === "start") {
                        startDate = utils.setHours(startDate, val);
                    } else {
                        endDate = utils.setHours(endDate, val);
                    }
                } else {
                    // Limit minutes to 0-59, with rollover
                    if (val > 59) {
                        val = 0;
                    } else if (val < 0) {
                        val = 59;
                    }
                    if (startEnd === "start") {
                        startDate = utils.setMinutes(startDate, val);
                    } else {
                        endDate = utils.setMinutes(endDate, val);
                    }
                }
                _this.props.onChange(startDate, endDate);
            };
        };
        return _this;
    }
    var _proto = DoubleCalendar.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.setState({
            currentState: "start"
        });
    };
    _proto.render = function render() {
        var currentMonth = this.state.currentMonth;
        var _props = this.props, classes = _props.classes, utils = _props.utils, startDate = _props.startDate, endDate = _props.endDate, t = _props.t;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classes.calendarWrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(calendar_header/* default */.Z, {
                            currentMonth: utils.getPreviousMonth(currentMonth),
                            onNextMonth: this.handleNextMonth,
                            onPreviousMonth: this.handlePreviousMonth,
                            leftArrowIcon: this.props.leftArrowIcon,
                            disablePrevMonth: this.shouldDisablePrevMonth(),
                            disableNextMonth: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classes.calendar,
                            children: this.renderWeeks(true)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classes.timeContainer,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                    variant: "filled",
                                    id: "hour",
                                    value: utils.getHours(startDate),
                                    label: t([
                                        "shared:hour"
                                    ], {
                                        defaultValue: "hour"
                                    }).titleCase,
                                    type: "number",
                                    className: classes.hour,
                                    inputProps: {
                                        className: classes.inputField
                                    },
                                    onChange: this.onChangeTime("start", "hour")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                    variant: "filled",
                                    id: "min",
                                    value: utils.getMinutes(startDate),
                                    label: t([
                                        "shared:abbrMinutes"
                                    ], {
                                        defaultValue: "min"
                                    }).titleCase,
                                    type: "number",
                                    className: classes.minute,
                                    inputProps: {
                                        className: classes.inputField
                                    },
                                    onChange: this.onChangeTime("start", "min")
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classes.vr,
                    children: "\xa0"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(calendar_header/* default */.Z, {
                            currentMonth: currentMonth,
                            onNextMonth: this.handleNextMonth,
                            onPreviousMonth: this.handlePreviousMonth,
                            rightArrowIcon: this.props.rightArrowIcon,
                            disablePrevMonth: true,
                            disableNextMonth: this.shouldDisableNextMonth()
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classes.calendar,
                            children: this.renderWeeks(false)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classes.timeContainer,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                    variant: "filled",
                                    id: "hour",
                                    label: t([
                                        "shared:hour"
                                    ], {
                                        defaultValue: "hour"
                                    }).titleCase,
                                    value: utils.getHours(endDate),
                                    type: "number",
                                    className: classes.hour,
                                    inputProps: {
                                        className: classes.inputField
                                    },
                                    onChange: this.onChangeTime("end", "hour")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                    variant: "filled",
                                    id: "min",
                                    label: t([
                                        "shared:abbrMinutes"
                                    ], {
                                        defaultValue: "min"
                                    }).titleCase,
                                    value: utils.getMinutes(endDate),
                                    type: "number",
                                    className: classes.minute,
                                    inputProps: {
                                        className: classes.inputField
                                    },
                                    onChange: this.onChangeTime("end", "min")
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    };
    return DoubleCalendar;
}(_Component = react.Component);
DoubleCalendar.defaultProps = {
    minDate: "1900-01-01",
    maxDate: "2100-01-01",
    disablePast: false,
    disableFuture: false,
    leftArrowIcon: undefined,
    rightArrowIcon: undefined,
    shouldDisableDate: function() {
        return false;
    }
};
var enhance = (0,Recompose_esm/* compose */.qC)(with_utils/* withUtils */.W, (0,withTranslation/* withTranslation */.Z)([
    "shared"
]), (0,with_styles/* withStyles */.D)(styles, {
    name: "MUITPickersCalendar"
}));
/* harmony default export */ var double_calendar = (enhance(DoubleCalendar));

;// CONCATENATED MODULE: ./components/pickers/date-time-range-picker/single-calendar.tsx












var single_calendar_styles = function(theme) {
    return {
        calendar: {
            height: 36 * 6,
            marginTop: theme.spacing(1.5)
        },
        week: {
            display: "flex",
            justifyContent: "center"
        },
        calendarWrapper: {
            display: "flex",
            justifyContent: "center"
        },
        hour: {
            maxWidth: "7em"
        },
        minute: {
            maxWidth: "7em"
        },
        timeContainer: {
            display: "flex",
            justifyContent: "space-evenly"
        }
    };
};
var single_calendar_Component;
/* eslint-disable no-unused-expressions */ var SingleCalendar = /*#__PURE__*/ function(_superClass) {
    "use strict";
    (0,_inherits/* default */.Z)(SingleCalendar, _superClass);
    var _super = (0,_create_super/* default */.Z)(SingleCalendar);
    function SingleCalendar() {
        (0,_class_call_check/* default */.Z)(this, SingleCalendar);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            currentMonth: _this.props.utils.startOfMonth(_this.props.date ? _this.props.date : new Date()),
            hoveredDay: null
        };
        _this.onDateSelect = function(day) {
            var _props = _this.props, date = _props.date, utils = _props.utils, onChange = _props.onChange;
            if (!date || !onChange) {
                return;
            }
            var withHours = utils.setHours(day, utils.getHours(date));
            var withMinutes = utils.setMinutes(withHours, utils.getMinutes(date));
            onChange(withMinutes, withMinutes);
        };
        _this.onDayHover = function(enter, day) {
            if (enter) {
                _this.setState({
                    hoveredDay: day
                });
            } else {
                _this.setState({
                    hoveredDay: null
                });
            }
        };
        _this.handleNextMonth = function() {
            _this.setState({
                currentMonth: _this.props.utils.getNextMonth(_this.state.currentMonth)
            });
        };
        _this.handlePreviousMonth = function() {
            _this.setState({
                currentMonth: _this.props.utils.getPreviousMonth(_this.state.currentMonth)
            });
        };
        _this.validateMinMaxDate = function(day) {
            var _props = _this.props, minDate = _props.minDate, maxDate = _props.maxDate, utils = _props.utils;
            var parsedMinDate = (0,_instanceof/* default */.Z)(minDate, Date) ? minDate : new Date(minDate !== null && minDate !== void 0 ? minDate : "");
            var parsedMaxDate = (0,_instanceof/* default */.Z)(maxDate, Date) ? maxDate : new Date(maxDate !== null && maxDate !== void 0 ? maxDate : "");
            return parsedMinDate && utils.isBeforeDay(day, parsedMinDate) || parsedMaxDate && utils.isAfterDay(day, parsedMaxDate);
        };
        _this.shouldDisablePrevMonth = function() {
            var _props = _this.props, utils = _props.utils, disablePast = _props.disablePast, minDate = _props.minDate;
            var now = new Date();
            return !utils.isBefore(utils.startOfMonth(disablePast && utils.isAfter(now, new Date(minDate !== null && minDate !== void 0 ? minDate : "")) ? now : new Date(minDate !== null && minDate !== void 0 ? minDate : "")), _this.state.currentMonth);
        };
        _this.shouldDisableNextMonth = function() {
            var _props = _this.props, utils = _props.utils, disableFuture = _props.disableFuture, maxDate = _props.maxDate;
            var now = new Date();
            return !utils.isAfter(utils.startOfMonth(disableFuture && utils.isBefore(now, new Date(maxDate !== null && maxDate !== void 0 ? maxDate : "")) ? now : new Date(maxDate !== null && maxDate !== void 0 ? maxDate : "")), _this.state.currentMonth);
        };
        _this.shouldDisableDate = function(day) {
            var _props = _this.props, disablePast = _props.disablePast, disableFuture = _props.disableFuture, shouldDisableDate = _props.shouldDisableDate, utils = _props.utils;
            var now = new Date();
            return disableFuture && utils.isAfterDay(day, now) || disablePast && utils.isBeforeDay(day, now) || _this.validateMinMaxDate(day) || (shouldDisableDate === null || shouldDisableDate === void 0 ? void 0 : shouldDisableDate(day));
        };
        _this.moveToDay = function(day) {
            var onChange = _this.props.onChange;
            if (onChange && day && !_this.shouldDisableDate(day)) {
                onChange(day);
            }
        };
        _this.renderWeeks = function(prev) {
            var utils = _this.props.utils;
            var currentMonth = _this.state.currentMonth;
            if (prev) {
                currentMonth = utils.getPreviousMonth(currentMonth);
            }
            var weeks = utils.getWeekArray(currentMonth);
            return weeks.map(function(week) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: _this.props.classes.week,
                    children: _this.renderDays(week, currentMonth)
                }, "week-".concat(week[0].toString()));
            });
        };
        _this.renderDays = function(week, currentMonth) {
            var date = _this.props.date;
            var utils = _this.props.utils;
            var currentMonthNumber = utils.getMonth(currentMonth);
            var now = new Date();
            if (date) {
                date = utils.startOfDay(date);
            }
            return week.map(function(day) {
                var disabled = _this.shouldDisableDate(day);
                var dayInCurrentMonth = utils.getMonth(day) === currentMonthNumber;
                var selected = date ? utils.isSameDay(date, day) : false;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(day_wrapper/* default */.Z, {
                    value: day,
                    dayInCurrentMonth: dayInCurrentMonth,
                    disabled: disabled,
                    onSelect: _this.onDateSelect,
                    onMouseEnter: _this.handleOnMouse(disabled, dayInCurrentMonth, day, true),
                    onMouseLeave: _this.handleOnMouse(disabled, dayInCurrentMonth, day, false),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(date_time_range_picker_day/* default */.Z, {
                        current: utils.isSameDay(day, now),
                        hidden: !dayInCurrentMonth,
                        disabled: disabled,
                        selected: selected,
                        betweenSelected: false,
                        children: utils.formatByString(day, "d")
                    })
                }, day.toString());
            });
        };
        _this.handleOnMouse = function(disabled, dayInCurrentMonth, day, enter) {
            return function() {
                if (!disabled && dayInCurrentMonth) {
                    _this.onDayHover(enter, day);
                }
            };
        };
        _this.onChangeTime = function(timeTarget) {
            return function(e) {
                var _props = _this.props, onChange = _props.onChange, utils = _props.utils;
                if (!onChange) {
                    return;
                }
                var _props1 = _this.props, _date = _props1.date, date = _date === void 0 ? new Date() : _date;
                var val = Number(e.target.value);
                if (timeTarget === "hour") {
                    val = (val % 24 + 24) % 24;
                    date = utils.setHours(date, val);
                } else {
                    val = (val % 60 + 60) % 60;
                    date = utils.setMinutes(date, val);
                }
                onChange(date);
            };
        };
        return _this;
    }
    var _proto = SingleCalendar.prototype;
    _proto.render = function render() {
        var currentMonth = this.state.currentMonth;
        var _props = this.props, classes = _props.classes, utils = _props.utils, _date = _props.date, date = _date === void 0 ? new Date() : _date, disableHours = _props.disableHours, t = _props.t;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classes.calendarWrapper,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(calendar_header/* default */.Z, {
                        currentMonth: currentMonth,
                        onNextMonth: this.handleNextMonth,
                        onPreviousMonth: this.handlePreviousMonth,
                        leftArrowIcon: this.props.leftArrowIcon,
                        rightArrowIcon: this.props.rightArrowIcon,
                        disablePrevMonth: this.shouldDisablePrevMonth(),
                        disableNextMonth: this.shouldDisableNextMonth()
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classes.calendar,
                        children: this.renderWeeks(false)
                    }),
                    !disableHours && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classes.timeContainer,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                variant: "filled",
                                id: "hour",
                                label: t([
                                    "shared:hour"
                                ], {
                                    defaultValue: "hour"
                                }).titleCase,
                                value: utils.getHours(date),
                                type: "number",
                                className: classes.hour,
                                inputProps: {
                                    style: {
                                        textAlign: "center"
                                    }
                                },
                                onChange: this.onChangeTime("hour")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                variant: "filled",
                                id: "min",
                                label: t([
                                    "shared:abbrMinutes"
                                ], {
                                    defaultValue: "min"
                                }).titleCase,
                                value: utils.getMinutes(date),
                                type: "number",
                                className: classes.minute,
                                inputProps: {
                                    style: {
                                        textAlign: "center"
                                    }
                                },
                                onChange: this.onChangeTime("min")
                            })
                        ]
                    })
                ]
            })
        });
    };
    return SingleCalendar;
}(single_calendar_Component = react.Component);
SingleCalendar.defaultProps = {
    date: undefined,
    minDate: "1900-01-01",
    maxDate: "2100-01-01",
    onChange: undefined,
    disablePast: false,
    disableFuture: false,
    leftArrowIcon: undefined,
    rightArrowIcon: undefined,
    shouldDisableDate: function() {
        return false;
    }
};
var single_calendar_enhance = (0,Recompose_esm/* compose */.qC)(with_utils/* withUtils */.W, (0,withTranslation/* withTranslation */.Z)([
    "shared"
]), (0,with_styles/* withStyles */.D)(single_calendar_styles, {
    name: "MUITPickersCalendar"
}));
/* harmony default export */ var single_calendar = (single_calendar_enhance(SingleCalendar));

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(99758);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.11.16_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.53_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Radio/Radio.js + 3 modules
var Radio = __webpack_require__(91310);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.11.16_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.53_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/RadioGroup/RadioGroup.js
var RadioGroup = __webpack_require__(75841);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.11.16_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.53_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/FormControl/FormControl.js
var FormControl = __webpack_require__(21267);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.11.16_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.53_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/FormControlLabel/FormControlLabel.js
var FormControlLabel = __webpack_require__(53435);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.11.16_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.53_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2046);
// EXTERNAL MODULE: ../../node_modules/.pnpm/tss-react@4.8.2_@emotion+react@11.10.6_@emotion+server@11.10.0_react@17.0.2/node_modules/tss-react/esm/mui.js + 15 modules
var mui = __webpack_require__(99109);
;// CONCATENATED MODULE: ./components/pickers/date-time-range-picker/recent-batches-selector.tsx










var useStyles = (0,mui/* makeStyles */.ZL)()(function(theme) {
    return {
        formControl: {
            margin: theme.spacing(3)
        },
        boxHeight: {
            height: "400px",
            overflowY: "scroll"
        }
    };
});
function RecentBatchesSelector(props) {
    var classes = useStyles().classes;
    var theme = (0,useTheme/* default */.Z)();
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(""), 2), value = ref[0], setValue = ref[1];
    var handleChange = function(event) {
        setValue(event.target.value);
        var selectedTime = props.batchItems.find(function(item) {
            return item.batchId === event.target.value;
        });
        if (!selectedTime) {
            return;
        }
        props.batchSelected(selectedTime);
    };
    var utils = props.utils, t = props.t;
    var getFromAndTo = function(start, end) {
        return t([
            "shared:dateRangeTo"
        ], {
            defaultValue: "{{fromDate}} to {{toDate}}",
            fromDate: utils.formatByString(start, "dd/MM - yyyy, HH:mm"),
            toDate: utils.formatByString(end, "dd/MM - yyyy, HH:mm")
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classes.boxHeight,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl/* default */.Z, {
            variant: "filled",
            component: "fieldset",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioGroup/* default */.Z, {
                "aria-label": "recent-batches",
                name: "recent-batches",
                value: value,
                onChange: handleChange,
                children: props.batchItems.map(function(item) {
                    if (item.actualStart) {
                        var start = new Date(item.actualStart);
                        var end = item.actualStop ? new Date(item.actualStop) : new Date();
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                            value: item.batchId,
                            // eslint-disable-next-line react/forbid-component-props
                            control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {
                                color: "primary",
                                style: {
                                    marginBottom: theme.spacing(1.5)
                                }
                            }),
                            label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "body2",
                                        children: item.batchNumber
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        color: "textSecondary",
                                        variant: "caption",
                                        children: getFromAndTo(start, end)
                                    })
                                ]
                            }),
                            labelPlacement: "end",
                            title: getFromAndTo(start, end)
                        }, item.batchId);
                    }
                })
            })
        })
    });
}

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(48417);
// EXTERNAL MODULE: ./graphql/queries/shift-times.gql
var shift_times = __webpack_require__(59964);
var shift_times_default = /*#__PURE__*/__webpack_require__.n(shift_times);
// EXTERNAL MODULE: ./helpers/schedule.ts
var schedule = __webpack_require__(40510);
;// CONCATENATED MODULE: ./components/pickers/date-time-range-picker/recent-shifts.tsx



















var recent_shifts_styles = function(theme) {
    return {
        fillHeight: {
            height: "100%"
        },
        loading: {
            width: "100%",
            height: "100%",
            display: "flex"
        },
        boxHeight: {
            height: "400px",
            overflowY: "scroll"
        }
    };
};
var zeroPadding = function(s) {
    if (typeof s === "string" && s.length < 2 || typeof s === "number" && s < 10) {
        return "0".concat(s);
    }
    return "".concat(s);
};
var RecentShifts = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(RecentShifts, _Component);
    var _super = (0,_create_super/* default */.Z)(RecentShifts);
    function RecentShifts() {
        (0,_class_call_check/* default */.Z)(this, RecentShifts);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            shiftIndex: null,
            shifts: [],
            configuration: null
        };
        _this.getFromAndTo = function(start, end) {
            var _props = _this.props, utils = _props.utils, t = _props.t;
            return t([
                "shared:dateRangeTo"
            ], {
                defaultValue: "{{fromDate}} to {{toDate}}",
                fromDate: utils.formatByString(start, "dd/MM - yyyy, HH:mm"),
                toDate: utils.formatByString(end, "dd/MM - yyyy, HH:mm")
            });
        };
        _this.getTimeRangeDates = function(timeRange) {
            var ref;
            // Convert the generic shift into a current shift.
            var currentDate = new Date();
            var ref1;
            var startDay = (ref1 = (ref = _this.state.configuration) === null || ref === void 0 ? void 0 : ref.startDayOfWeek) !== null && ref1 !== void 0 ? ref1 : schema/* DayOfWeek.MONDAY */.eO.MONDAY;
            var ref2 = (0,schedule/* convertGenericShiftTimeToDatePair */.VL)(timeRange, currentDate, startDay), startDate = ref2.from, endDate = ref2.to;
            // If start date is prior to now, than we need to move a week back and find the start date again.
            if (currentDate < startDate) {
                var lastWeek = new Date(currentDate.getTime() - 7..days);
                var ref3 = (0,schedule/* convertGenericShiftTimeToDatePair */.VL)(timeRange, lastWeek, startDay), startDate1 = ref3.from, endDate1 = ref3.to;
                return {
                    startDate: startDate1,
                    endDate: endDate1
                };
            } else {
                return {
                    startDate: startDate,
                    endDate: endDate
                };
            }
        };
        _this.handleChange = function(event) {
            var _target = event.target, shiftId = _target.value;
            _this.setState({
                shiftIndex: shiftId
            });
            var selectedShift = _this.state.shifts.find(function(item) {
                return item.id === shiftId;
            });
            if (!selectedShift) {
                return;
            }
            var ref = _this.getTimeRangeDates(selectedShift.timeRange), startDate = ref.startDate, endDate = ref.endDate;
            _this.props.updateTime(startDate, endDate);
        };
        _this.handleOnCompleted = function(data) {
            var ref, ref1;
            var ref2;
            var shifts = (0,_to_consumable_array/* default */.Z)((ref2 = (ref = data.line.schedule) === null || ref === void 0 ? void 0 : ref.shifts) !== null && ref2 !== void 0 ? ref2 : []);
            var ref3;
            var configuration = (ref3 = (ref1 = data.line.schedule) === null || ref1 === void 0 ? void 0 : ref1.configuration) !== null && ref3 !== void 0 ? ref3 : null;
            if (shifts.length) {
                var ref4, ref5;
                shifts.sort(function(a, b) {
                    var aDay = (0,schedule/* getDaySortNumber */.XS)(a.timeRange.from.day, configuration === null || configuration === void 0 ? void 0 : configuration.startDayOfWeek);
                    var bDay = (0,schedule/* getDaySortNumber */.XS)(b.timeRange.from.day, configuration === null || configuration === void 0 ? void 0 : configuration.startDayOfWeek);
                    var aHour = a.timeRange.from.hour;
                    var bHour = b.timeRange.from.hour;
                    if (aDay < bDay) {
                        return -1;
                    } else if (aDay === bDay && (aHour < bHour || aHour === bHour && a.timeRange.from.minute < b.timeRange.from.minute)) {
                        return -1;
                    }
                    return 1;
                });
                if (!_this.state.shifts.length) {
                    _this.setState({
                        shifts: shifts
                    });
                    _this.props.updateShifts(shifts.length);
                }
                if (_this.state.configuration === null || ((ref4 = _this.state) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.configuration) === null || ref5 === void 0 ? void 0 : ref5.startDayOfWeek) !== (configuration === null || configuration === void 0 ? void 0 : configuration.startDayOfWeek)) {
                    _this.setState({
                        configuration: configuration
                    });
                }
            }
        };
        return _this;
    }
    var _proto = RecentShifts.prototype;
    _proto.render = function render() {
        var _this = this;
        var _props = this.props, lineId = _props.lineId, classes = _props.classes, theme = _props.theme;
        var currentDate = new Date();
        var nowFilter = (0,schedule/* getYearWeek */.dl)(currentDate);
        var scheduleVariables = {
            lineId: lineId,
            validIn: nowFilter
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Query/* Query */.A, {
            query: (shift_times_default()),
            ssr: false,
            partialRefetch: true,
            fetchPolicy: "cache-and-network",
            onCompleted: this.handleOnCompleted,
            errorPolicy: "all" // Necessary for returning partial data.
            ,
            variables: scheduleVariables,
            children: function(param) {
                var data = param.data, loading = param.loading;
                if (loading && !data) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classes.loading,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_or_error/* default */.Z, {
                            loading: true
                        })
                    });
                }
                var t = _this.props.t;
                var shifts = function() {
                    var shifts = _this.state.shifts;
                    return shifts || [];
                }();
                if (shifts.length) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classes.boxHeight,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl/* default */.Z, {
                            variant: "filled",
                            component: "fieldset",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioGroup/* default */.Z, {
                                "aria-label": "recent-batches",
                                name: "recent-batches",
                                value: _this.state.shiftIndex,
                                onChange: _this.handleChange,
                                children: shifts.map(function(item) {
                                    var ref = _this.getTimeRangeDates(item.timeRange), startDate = ref.startDate, endDate = ref.endDate;
                                    return {
                                        item: item,
                                        startDate: startDate,
                                        endDate: endDate
                                    };
                                }).sort(function(param, param1) {
                                    var leftStartDate = param.startDate, rightStartDate = param1.startDate;
                                    return rightStartDate.getTime() - leftStartDate.getTime();
                                }).map(function(param) {
                                    var startDate = param.startDate, endDate = param.endDate, item = param.item;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                        value: item.id,
                                        control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {
                                            color: "primary",
                                            style: {
                                                marginBottom: theme.spacing(1.5)
                                            }
                                        }),
                                        label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: "body2",
                                                    children: "".concat((0,schedule/* getDayStringOfEnum */.g_)(t, item.timeRange.from.day), ": ").concat(item.name)
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    color: "textSecondary",
                                                    variant: "caption",
                                                    children: "".concat((0,schedule/* getDayStringOfEnum */.g_)(t, item.timeRange.from.day), " ").concat(zeroPadding(item.timeRange.from.hour), ":").concat(zeroPadding(item.timeRange.from.minute), " - ").concat((0,schedule/* getDayStringOfEnum */.g_)(t, item.timeRange.to.day), " ").concat(zeroPadding(item.timeRange.to.hour), ":").concat(zeroPadding(item.timeRange.to.minute))
                                                })
                                            ]
                                        }),
                                        labelPlacement: "end",
                                        title: _this.getFromAndTo(startDate, endDate)
                                    }, item.id);
                                })
                            })
                        })
                    });
                } else {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        color: "secondary",
                        align: "center",
                        children: t([
                            "shared:noShifts"
                        ], {
                            defaultValue: "No shifts. Go to your schedule to set up your shift times."
                        })
                    });
                }
            }
        });
    };
    return RecentShifts;
}(react.Component);
var recent_shifts_enhance = (0,Recompose_esm/* compose */.qC)((0,with_styles/* withStyles */.D)(recent_shifts_styles, {
    withTheme: true
}));
/* harmony default export */ var recent_shifts = (recent_shifts_enhance(RecentShifts));

// EXTERNAL MODULE: ./contexts/timepicker.tsx
var timepicker = __webpack_require__(80484);
;// CONCATENATED MODULE: ./components/pickers/date-time-range-picker/relative-times.tsx







var relative_times_useStyles = (0,mui/* makeStyles */.ZL)()(function(theme) {
    return {
        relativeTimes: {
            border: "1px solid #ddd",
            padding: "10px"
        },
        btnClass: {
            margin: "5px"
        },
        spanWidth: {
            width: "70px",
            display: "inline-block"
        }
    };
});
var minutes = [
    1,
    3,
    5,
    15,
    30,
    45
].map(function(numMinutes) {
    return numMinutes.minutes;
});
var hours = [
    1,
    2,
    3,
    6,
    8,
    12
].map(function(numHours) {
    return numHours.hours;
});
var days = [
    1,
    2,
    3,
    4,
    5,
    6
].map(function(numDays) {
    return numDays.days;
});
var weeks = [
    1,
    2,
    4,
    6
].map(function(numWeeks) {
    return (numWeeks * 7).days;
});
var months = [
    3
].map(function(numMonths) {
    return (numMonths * 30).days;
});
var RelativeTimes = function(props) {
    var classes = relative_times_useStyles().classes;
    var t = props.t;
    var ref = (0,react.useContext)(timepicker/* TimepickerContext */.Ai), from = ref.from, to = ref.to;
    var ref1 = (0,react.useState)(function() {
        var initialDuration = ((to === null || to === void 0 ? void 0 : to.getTime()) || Date.now()) - from.getTime();
        var ref;
        return (ref = (0,_to_consumable_array/* default */.Z)(months).concat((0,_to_consumable_array/* default */.Z)(weeks), (0,_to_consumable_array/* default */.Z)(days), (0,_to_consumable_array/* default */.Z)(hours), (0,_to_consumable_array/* default */.Z)(minutes)).find(function(duration) {
            return duration === initialDuration;
        })) !== null && ref !== void 0 ? ref : null;
    }), selectionValue = ref1[0], setSelectionValue = ref1[1];
    var onChangeRelativeTime = function(duration) {
        return function() {
            setSelectionValue(duration);
            var now = Date.now();
            props.updateTime(new Date(now - duration), new Date(now));
        };
    };
    var renderTimings = function(durations, miliToDuration) {
        return durations.map(function(duration) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                className: classes.btnClass,
                color: selectionValue === duration ? "primary" : "inherit",
                variant: "contained",
                onClick: onChangeRelativeTime(duration),
                children: duration / miliToDuration
            }, duration);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classes.relativeTimes,
                children: [
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        className: classes.spanWidth,
                        children: [
                            t([
                                "shared:minutes"
                            ], {
                                defaultValue: "Minutes"
                            }),
                            " ",
                            ": "
                        ]
                    }),
                    " ",
                    renderTimings(minutes, 1..minutes),
                    " "
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classes.relativeTimes,
                children: [
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        className: classes.spanWidth,
                        children: [
                            t([
                                "shared:hours"
                            ], {
                                defaultValue: "Hours"
                            }),
                            " ",
                            ": "
                        ]
                    }),
                    " ",
                    renderTimings(hours, 1..hours),
                    " "
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classes.relativeTimes,
                children: [
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        className: classes.spanWidth,
                        children: [
                            t([
                                "shared:days"
                            ], {
                                defaultValue: "Days"
                            }),
                            " ",
                            ": "
                        ]
                    }),
                    " ",
                    renderTimings(days, 1..days),
                    " "
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classes.relativeTimes,
                children: [
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        className: classes.spanWidth,
                        children: [
                            t([
                                "shared:weeks"
                            ], {
                                defaultValue: "Weeks"
                            }),
                            " ",
                            ": "
                        ]
                    }),
                    " ",
                    renderTimings(weeks, 7..days),
                    " "
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classes.relativeTimes,
                children: [
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        className: classes.spanWidth,
                        children: [
                            t([
                                "shared:months"
                            ], {
                                defaultValue: "Months"
                            }),
                            " ",
                            ": "
                        ]
                    }),
                    " ",
                    renderTimings(months, 30..days),
                    " "
                ]
            })
        ]
    });
};
/* harmony default export */ var relative_times = (RelativeTimes);

// EXTERNAL MODULE: ./graphql/queries/recent-batches-from-line.gql
var recent_batches_from_line = __webpack_require__(72365);
var recent_batches_from_line_default = /*#__PURE__*/__webpack_require__.n(recent_batches_from_line);
// EXTERNAL MODULE: ./helpers/helper-functions.ts
var helper_functions = __webpack_require__(15608);
// EXTERNAL MODULE: ./hocs/with-line.tsx
var with_line = __webpack_require__(41440);
// EXTERNAL MODULE: ./hocs/with-device.tsx
var with_device = __webpack_require__(90749);
// EXTERNAL MODULE: ./hocs/with-width.tsx
var with_width = __webpack_require__(74782);
;// CONCATENATED MODULE: ./components/pickers/date-time-range-picker/date-time-picker.tsx
































var date_time_picker_styles = function(theme) {
    return {
        card: {
            display: "block"
        },
        content: {
            overflowX: "auto"
        },
        actionContainer: {
            justifyContent: "space-between",
            padding: theme.spacing(2),
            flexWrap: "wrap"
        },
        actionTypography: {
            display: "flex",
            marginBottom: 4,
            marginTop: 4
        },
        actionButtonGroup: {
            display: "flex",
            flexGrow: 1,
            justifyContent: "end"
        },
        actionButton: {
            minWidth: "80px"
        },
        loading: {
            width: "100%",
            height: "100%",
            display: "flex"
        },
        modalContainer: {
            overflow: "scroll",
            maxHeight: "calc(calc(90vh - env(safe-area-inset-bottom)) - env(safe-area-inset-top))",
            maxWidth: "calc(calc(100vw - env(safe-area-inset-left)) - env(safe-area-inset-right))",
            border: "none",
            margin: "auto"
        },
        doubleCalendarError: {
            paddingLeft: theme.spacing(2),
            margin: theme.spacing(),
            marginTop: theme.spacing(2)
        }
    };
};
var CustomDateTimePicker = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(CustomDateTimePicker, _Component);
    var _super = (0,_create_super/* default */.Z)(CustomDateTimePicker);
    function CustomDateTimePicker() {
        (0,_class_call_check/* default */.Z)(this, CustomDateTimePicker);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            internalStartDate: null,
            internalEndDate: null,
            disableOkButton: false,
            timePickerError: null,
            customTabValue: 0,
            recentBatches: 0,
            shifts: 0
        };
        _this.updateShiftsInState = function(value) {
            _this.setState({
                shifts: value
            });
        };
        _this.formatDate = function(utils, date) {
            return date ? (0,helper_functions/* isBrowserLocale24h */._t)(_this.props.i18n.language) ? utils.formatByString(date, "dd/MM - yyyy, HH:mm") : utils.formatByString(date, "MM/dd/yyyy, hh:mm a") : "";
        };
        _this.startDate = function(from) {
            if (_this.state.internalStartDate) {
                return _this.state.internalStartDate;
            } else if (from) {
                return from;
            }
            // NOTE: Should not get to here, but we fallback to current date.
            return new Date();
        };
        _this.endDate = function(to) {
            if (_this.state.internalEndDate) {
                if (_this.state.internalEndDate === -1) {
                    return null;
                } else {
                    return _this.state.internalEndDate;
                }
            } else if (to) {
                return to;
            }
            return null;
        };
        _this.updateTime = function(start, end) {
            _this.setState({
                internalStartDate: start,
                internalEndDate: end
            });
            if (end && start > end) {
                _this.setState({
                    timePickerError: true,
                    disableOkButton: true
                });
            } else {
                _this.setState({
                    timePickerError: null,
                    disableOkButton: false
                });
            }
        };
        _this.getCalendar = function(range) {
            var _props = _this.props, disableHours = _props.disableHours, disablePast = _props.disablePast, disableFuture = _props.disableFuture, leftArrowIcon = _props.leftArrowIcon, rightArrowIcon = _props.rightArrowIcon, utils = _props.utils, t = _props.t, shouldDisableDate = _props.shouldDisableDate, minDate = _props.minDate, maxDate = _props.maxDate, from = _props.from, to = _props.to;
            if (range) {
                var ref, ref1;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(double_calendar, {
                            startDate: _this.startDate(from),
                            endDate: _this.endDate(to) || new Date(),
                            onChange: _this.updateTime,
                            disablePast: disablePast || false,
                            disableFuture: disableFuture || false,
                            minDate: (ref = utils.date(minDate || "1900-01-01")) !== null && ref !== void 0 ? ref : undefined,
                            maxDate: (ref1 = utils.date(maxDate || "2100-01-01")) !== null && ref1 !== void 0 ? ref1 : undefined,
                            leftArrowIcon: leftArrowIcon || /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowBack/* default */.Z, {}),
                            rightArrowIcon: rightArrowIcon || /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForward/* default */.Z, {}),
                            shouldDisableDate: shouldDisableDate
                        }),
                        _this.state.timePickerError !== null && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(wide_snackbar/* default */.Z, {
                                    className: _this.props.classes.doubleCalendarError,
                                    message: t([
                                        "shared:negativeTimeNotAllowed"
                                    ], {
                                        defaultValue: "Your end time cannot be before your start time"
                                    })
                                }),
                                " "
                            ]
                        })
                    ]
                });
            } else {
                var ref2, ref3;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(single_calendar, {
                    disableHours: disableHours,
                    date: _this.startDate(from),
                    onChange: _this.updateTime,
                    disablePast: disablePast || false,
                    disableFuture: disableFuture || false,
                    minDate: (ref2 = utils.date(minDate || "1900-01-01")) !== null && ref2 !== void 0 ? ref2 : undefined,
                    maxDate: (ref3 = utils.date(maxDate || "2100-01-01")) !== null && ref3 !== void 0 ? ref3 : undefined,
                    leftArrowIcon: leftArrowIcon || /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowBack/* default */.Z, {}),
                    rightArrowIcon: rightArrowIcon || /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForward/* default */.Z, {}),
                    shouldDisableDate: shouldDisableDate
                });
            }
        };
        _this.getSelectedText = function(range) {
            var _props = _this.props, classes = _props.classes, utils = _props.utils, t = _props.t, from = _props.from, to = _props.to;
            if (range && from && to) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classes.actionTypography,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            color: "primary",
                            children: [
                                t([
                                    "shared:selected"
                                ], {
                                    defaultValue: "Selected"
                                }).toUpperCase(),
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            style: {
                                marginLeft: "5px"
                            },
                            children: _this.formatDate(utils, _this.startDate(from))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            color: "primary",
                            style: {
                                marginLeft: "5px"
                            },
                            children: t([
                                "shared:dateTo"
                            ], {
                                defaultValue: "to"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            style: {
                                marginLeft: "5px"
                            },
                            children: _this.formatDate(utils, _this.endDate(to))
                        })
                    ]
                });
            }
        };
        _this.handleChangeCustomTab = function(_event, newValue) {
            _this.setState({
                customTabValue: newValue
            });
        };
        _this.TabPanel = function(props) {
            var _props = _this.props, theme = _props.theme, classes = _props.classes;
            var children = props.children, value = props.value, index = props.index;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                role: "tabpanel",
                hidden: value !== index,
                id: "calender-tabpanel-".concat(index),
                "aria-labelledby": "calender-tab-".concat(index),
                className: classes.content,
                children: value === index && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    p: 3,
                    style: {
                        paddingTop: theme.spacing()
                    },
                    children: children
                })
            });
        };
        _this.selectedBatchTimes = function(selectedTimes) {
            var end = selectedTimes.actualStop ? new Date(selectedTimes.actualStop) : new Date();
            var start = selectedTimes.actualStart ? new Date(selectedTimes.actualStart) : new Date(end.getTime() - 1..hours);
            _this.updateTime(start, end);
        };
        _this.getRecentBatches = function() {
            var classes = _this.props.classes;
            var _lineId;
            var lineId = (_lineId = _this.props.lineId) !== null && _lineId !== void 0 ? _lineId : _this.props.deviceLineId;
            if (!lineId) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classes.loading,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_or_error/* default */.Z, {
                        loading: false
                    })
                });
            }
            var batchVariables = {
                lineId: lineId,
                filter: {
                    state: schema/* BatchState.COMPLETED */.AM.COMPLETED,
                    exclusiveFromCheck: false
                }
            };
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Query/* Query */.A, {
                ssr: false,
                partialRefetch: true,
                query: (recent_batches_from_line_default()),
                errorPolicy: "all" // Necessary for returning partial data.
                ,
                fetchPolicy: "cache-and-network",
                variables: batchVariables,
                children: function(param) {
                    var batchResponse = param.data, loading = param.loading;
                    var ref;
                    var t = _this.props.t;
                    if (loading && !batchResponse) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classes.loading,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_or_error/* default */.Z, {
                                loading: true
                            })
                        });
                    }
                    var fieldName = "line";
                    var batchLine = batchResponse && batchResponse[fieldName];
                    var ref1;
                    var items = (ref1 = batchLine === null || batchLine === void 0 ? void 0 : (ref = batchLine.batches) === null || ref === void 0 ? void 0 : ref.items) !== null && ref1 !== void 0 ? ref1 : [];
                    if (items.length > 0) {
                        if (items.length !== _this.state.recentBatches) {
                            _this.setState({
                                recentBatches: items.length
                            });
                        }
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(RecentBatchesSelector, {
                            utils: _this.props.utils,
                            batchItems: items,
                            batchSelected: _this.selectedBatchTimes,
                            t: t
                        });
                    } else {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            align: "center",
                            color: "secondary",
                            children: [
                                " ",
                                t([
                                    "shared:NotRunningBatches"
                                ], {
                                    defaultValue: "You have not run any batches yet. Go to the Batches tab to start your first batch."
                                }),
                                " "
                            ]
                        });
                    }
                }
            });
        };
        _this.renderTabs = function() {
            var _props = _this.props, t = _props.t, lineId = _props.lineId;
            var tabs = [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* default */.Z, {
                    label: t([
                        "shared:calendar"
                    ], {
                        defaultValue: "Calendar"
                    }),
                    "aria-controls": "calendar-tabpanel-0",
                    id: "calendar-tab-0"
                }, 0),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* default */.Z, {
                    label: t([
                        "shared:relative"
                    ], {
                        defaultValue: "Relative"
                    }),
                    "aria-controls": "calendar-tabpanel-1",
                    id: "calendar-tab-1"
                }, 1), 
            ];
            if (lineId) {
                tabs.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* default */.Z, {
                    label: t([
                        "shared:recent-batches"
                    ], {
                        defaultValue: "Recent batches"
                    }),
                    "aria-controls": "calendar-tabpanel-2",
                    id: "calendar-tab-2"
                }, 2), /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* default */.Z, {
                    label: t([
                        "shared:recent-shifts"
                    ], {
                        defaultValue: "Recent shifts"
                    }),
                    "aria-controls": "calendar-tabpanel-3",
                    id: "calendar-tab-3"
                }, 3));
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* default */.Z, {
                variant: "scrollable",
                value: _this.state.customTabValue,
                onChange: _this.handleChangeCustomTab,
                "aria-label": "calender tabs",
                indicatorColor: "primary",
                textColor: "primary",
                children: tabs
            });
        };
        _this.onClose = function() {
            var _props, ref;
            (ref = (_props = _this.props).onCancel) === null || ref === void 0 ? void 0 : ref.call(_props);
            _this.props.closePicker();
        };
        _this.onOk = function() {
            var _props = _this.props, from = _props.from, to = _props.to, setTime = _props.setTime;
            setTime(_this.startDate(from), _this.endDate(to));
        };
        return _this;
    }
    var _proto = CustomDateTimePicker.prototype;
    _proto.getOuter = function getOuter(children) {
        var _props = this.props, anchorEl = _props.anchorEl, open = _props.open, classes = _props.classes;
        if (this.props.width === "xs") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                open: open,
                onClose: this.onClose,
                disableScrollLock: false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classes.modalContainer,
                    children: children
                })
            });
        } else {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover/* default */.ZP, {
                open: open,
                anchorEl: anchorEl,
                anchorOrigin: {
                    vertical: "center",
                    horizontal: "center"
                },
                transformOrigin: {
                    vertical: "top",
                    horizontal: "center"
                },
                onClose: this.onClose,
                children: children
            });
        }
    };
    _proto.render = function render() {
        var _props = this.props, classes = _props.classes, t = _props.t, showTabs = _props.showTabs, _range = _props.range, range = _range === void 0 ? false : _range;
        var _lineId;
        var lineId = (_lineId = this.props.lineId) !== null && _lineId !== void 0 ? _lineId : this.props.deviceLineId;
        return this.getOuter(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
            elevation: 1,
            className: classes.card,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        showTabs && this.renderTabs(),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(this.TabPanel, {
                            value: this.state.customTabValue,
                            index: 0,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent/* default */.Z, {
                                children: this.getCalendar(range)
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(this.TabPanel, {
                            value: this.state.customTabValue,
                            index: 1,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(relative_times, {
                                t: t,
                                updateTime: this.updateTime
                            })
                        }),
                        lineId && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(this.TabPanel, {
                                    value: this.state.customTabValue,
                                    index: 2,
                                    children: this.getRecentBatches()
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(this.TabPanel, {
                                    value: this.state.customTabValue,
                                    index: 3,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(recent_shifts, {
                                        lineId: lineId,
                                        updateTime: this.updateTime,
                                        utils: this.props.utils,
                                        updateShifts: this.updateShiftsInState,
                                        t: t
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardActions/* default */.Z, {
                    className: classes.actionContainer,
                    children: [
                        this.getSelectedText(range),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classes.actionButtonGroup,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    size: "small",
                                    variant: "contained",
                                    color: "primary",
                                    onClick: this.onClose,
                                    className: classes.actionButton,
                                    children: t([
                                        "shared:cancel"
                                    ], {
                                        defaultValue: "Cancel"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    style: {
                                        marginLeft: 8
                                    },
                                    size: "small",
                                    variant: "contained",
                                    color: "primary",
                                    onClick: this.onOk,
                                    className: classes.actionButton,
                                    disabled: this.state.disableOkButton,
                                    children: t([
                                        "shared:ok"
                                    ], {
                                        defaultValue: "Ok"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        }));
    };
    return CustomDateTimePicker;
}(react.Component);
var date_time_picker_enhance = (0,Recompose_esm/* compose */.qC)(with_utils/* withUtils */.W, with_line/* withLine */.X, with_device/* withDevice */.v, (0,withTranslation/* withTranslation */.Z)([
    "shared"
]), (0,with_styles/* withStyles */.D)(date_time_picker_styles, {
    withTheme: true
}), (0,with_width/* withWidth */.of)());
/* harmony default export */ var date_time_picker = (date_time_picker_enhance(CustomDateTimePicker));


/***/ }),

/***/ 19101:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4656);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86533);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93089);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59106);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78391);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29901);








var _PureComponent;
var DayWrapper = /*#__PURE__*/ function(_superClass) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(DayWrapper, _superClass);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(DayWrapper);
    function DayWrapper() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, DayWrapper);
        var _this;
        _this = _super.apply(this, arguments);
        _this.handleClick = function() {
            _this.props.onSelect(_this.props.value);
        };
        return _this;
    }
    var _proto = DayWrapper.prototype;
    _proto.render = function render() {
        var _props = this.props, children = _props.children, value = _props.value, dayInCurrentMonth = _props.dayInCurrentMonth, disabled = _props.disabled, onSelect = _props.onSelect, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_props, [
            "children",
            "value",
            "dayInCurrentMonth",
            "disabled",
            "onSelect"
        ]);
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
            onClick: dayInCurrentMonth && !disabled ? this.handleClick : undefined,
            onKeyPress: dayInCurrentMonth && !disabled ? this.handleClick : undefined,
            role: "presentation"
        }, other), {
            children: children
        }));
    };
    return DayWrapper;
}(_PureComponent = react__WEBPACK_IMPORTED_MODULE_1__.PureComponent);
DayWrapper.defaultProps = {
    dayInCurrentMonth: true,
    disabled: false
};
/* harmony default export */ __webpack_exports__["Z"] = (DayWrapper);


/***/ }),

/***/ 81013:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37705);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93089);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59106);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var _mui_material_IconButton__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10016);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14517);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29901);
/* harmony import */ var _hocs_with_styles__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5887);









var styles = function(theme) {
    return {
        day: {
            width: 36,
            height: 36,
            fontSize: theme.typography.caption.fontSize,
            margin: "0 2px",
            color: theme.palette.text.primary,
            fontWeight: theme.typography.fontWeightMedium,
            "&:hover": {
                border: "1px solid ".concat(theme.palette.primary.main)
            }
        },
        hidden: {
            opacity: 0,
            pointerEvents: "none"
        },
        current: {
            color: theme.palette.primary.main,
            fontWeight: 600
        },
        selectedColor: {
            color: theme.palette.common.white,
            backgroundColor: theme.palette.primary.main,
            fontWeight: theme.typography.fontWeightMedium
        },
        betweenSelected: {
            color: theme.palette.common.black,
            backgroundColor: "".concat(theme.palette.primary.main, "30"),
            fontWeight: theme.typography.fontWeightMedium
        },
        disabled: {
            pointerEvents: "none",
            color: theme.palette.text.disabled
        }
    };
};
var Day = function(props) {
    var children = props.children, classes = props.classes, disabled = props.disabled, hidden = props.hidden, current = props.current, selected = props.selected, betweenSelected = props.betweenSelected, className = props.className, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, [
        "children",
        "classes",
        "disabled",
        "hidden",
        "current",
        "selected",
        "betweenSelected",
        "className"
    ]);
    var _obj;
    var extendedClassName = (0,clsx__WEBPACK_IMPORTED_MODULE_3__["default"])(classes.day, className, (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, classes.hidden, hidden), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, classes.current, current), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, classes.selectedColor, selected), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, classes.betweenSelected, betweenSelected && !selected && !disabled && !hidden), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, classes.disabled, disabled), _obj));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_IconButton__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        className: extendedClassName,
        tabIndex: hidden || disabled ? -1 : 0
    }, other), {
        size: "large",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
            children: [
                " ",
                children,
                " "
            ]
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,_hocs_with_styles__WEBPACK_IMPORTED_MODULE_8__/* .withStyles */ .D)(styles, {
    name: "MuiPickersDay"
})(Day));


/***/ }),

/***/ 63917:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _date_time_picker__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47864);








/* harmony default export */ __webpack_exports__["ZP"] = (_date_time_picker__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);


/***/ }),

/***/ 40510:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$2": function() { return /* binding */ getDayEnumFromDay; },
/* harmony export */   "Dd": function() { return /* binding */ getShiftFromShifts; },
/* harmony export */   "VL": function() { return /* binding */ convertGenericShiftTimeToDatePair; },
/* harmony export */   "Vc": function() { return /* binding */ extractCurrentSchedule; },
/* harmony export */   "XS": function() { return /* binding */ getDaySortNumber; },
/* harmony export */   "bb": function() { return /* binding */ unrollSchedule; },
/* harmony export */   "dl": function() { return /* binding */ getYearWeek; },
/* harmony export */   "g_": function() { return /* binding */ getDayStringOfEnum; },
/* harmony export */   "ku": function() { return /* binding */ getDayNumberOfEnum; },
/* harmony export */   "yV": function() { return /* binding */ mkAppointmentsFromShifts; }
/* harmony export */ });
/* unused harmony export shiftDuration */
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99758);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48417);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19852);
/* harmony import */ var generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25955);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52108);





// CC-BY-CA: https://stackoverflow.com/a/6117889
var getYearWeek = function(d) {
    // Copy date so don't modify original
    d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
    // Set to nearest Thursday: current date + 4 - current day number
    // Make Sunday's day number 7
    d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
    // Get first day of year
    var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
    // Calculate full weeks to nearest Thursday
    var weekNo = Math.ceil(((d.getTime() - yearStart.getTime()) / 86400000 + 1) / 7);
    // Return array of year and week number
    return {
        year: d.getUTCFullYear(),
        week: weekNo
    };
};
/**
 * Extract the schedule that is valid in the date you request. If not supplied
 * an array of schedules, it will return the schedule immediately.
 */ var extractCurrentSchedule = function(schedules, date) {
    var target = getYearWeek(date);
    if (!Array.isArray(schedules)) {
        return schedules;
    }
    // If we only have one schedule (usually the case from our request), we take it directly.
    if (schedules.length === 1) {
        return schedules[0];
    } else if (schedules.length > 1) {
        // If we are given more schedules, find the one that is the currently active one, based on the `validFrom` periods.
        var activeSchedule;
        schedules.map(function(schedule) {
            if (schedule.validFrom.year <= target.year && schedule.validFrom.week <= target.week) {
                // If no schedule has been set, just set the initial one.
                if (!activeSchedule) {
                    activeSchedule = schedule;
                    return;
                }
                // Check if the schedule's validFrom period is closer to our target, than the current `activeSchedule`.
                var scheduleYearDiff = target.year - schedule.validFrom.year;
                var activeScheduleYearDiff = target.year - activeSchedule.validFrom.year;
                var scheduleWeekDiff = target.week - schedule.validFrom.week;
                var activeScheduleWeekDiff = target.week - activeSchedule.validFrom.week;
                if (scheduleYearDiff <= activeScheduleYearDiff && scheduleWeekDiff < activeScheduleWeekDiff) {
                    activeSchedule = schedule;
                    return;
                }
            }
        });
        return activeSchedule;
    }
    return undefined;
};
/**
 * Convert a `DayOfWeek` enum to a string.
 */ var getDayStringOfEnum = function(t, dayOfWeek) {
    switch(dayOfWeek){
        case 0:
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.SUNDAY */ .eO.SUNDAY:
            return t([
                "shared:sunday"
            ], {
                defaultValue: "Sunday"
            });
        case 1:
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.MONDAY */ .eO.MONDAY:
            return t([
                "shared:monday"
            ], {
                defaultValue: "Monday"
            });
        case 2:
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.TUESDAY */ .eO.TUESDAY:
            return t([
                "shared:tuesday"
            ], {
                defaultValue: "Tuesday"
            });
        case 3:
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.WEDNESDAY */ .eO.WEDNESDAY:
            return t([
                "shared:wednesday"
            ], {
                defaultValue: "Wednesday"
            });
        case 4:
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.THURSDAY */ .eO.THURSDAY:
            return t([
                "shared:thursday"
            ], {
                defaultValue: "Thursday"
            });
        case 5:
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.FRIDAY */ .eO.FRIDAY:
            return t([
                "shared:friday"
            ], {
                defaultValue: "Friday"
            });
        case 6:
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.SATURDAY */ .eO.SATURDAY:
            return t([
                "shared:saturday"
            ], {
                defaultValue: "Saturday"
            });
        default:
            _types__WEBPACK_IMPORTED_MODULE_1__/* .assertUnreachable */ .U(dayOfWeek);
            return t([
                "shared:monday"
            ], {
                defaultValue: "Monday"
            });
    }
};
/**
 * Convert a day 'number' into a `DayOfWeek` enum.
 */ var getDayEnumFromDay = function(dayOfWeek) {
    switch(dayOfWeek){
        case 0:
            return generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.SUNDAY */ .eO.SUNDAY;
        case 1:
            return generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.MONDAY */ .eO.MONDAY;
        case 2:
            return generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.TUESDAY */ .eO.TUESDAY;
        case 3:
            return generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.WEDNESDAY */ .eO.WEDNESDAY;
        case 4:
            return generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.THURSDAY */ .eO.THURSDAY;
        case 5:
            return generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.FRIDAY */ .eO.FRIDAY;
        case 6:
            return generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.SATURDAY */ .eO.SATURDAY;
        default:
            return generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.MONDAY */ .eO.MONDAY;
    }
};
/**
 * Convert a `DayOfWeek` enum to a sortable number, rotating it based on `startDayOfWeek`.
 */ var getDaySortNumber = function(dayOfWeek) {
    var startDayOfWeek = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.SUNDAY */ .eO.SUNDAY;
    // Figure out what the start day is so we can rotate by this number.
    var foundStartDay = getDayNumberOfEnum(startDayOfWeek);
    var sortNumber = 0;
    switch(dayOfWeek){
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.SUNDAY */ .eO.SUNDAY:
            sortNumber = 0 < foundStartDay ? 0 + 7 : 0;
            break;
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.MONDAY */ .eO.MONDAY:
            sortNumber = 1 < foundStartDay ? 1 + 7 : 1;
            break;
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.TUESDAY */ .eO.TUESDAY:
            sortNumber = 2 < foundStartDay ? 2 + 7 : 2;
            break;
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.WEDNESDAY */ .eO.WEDNESDAY:
            sortNumber = 3 < foundStartDay ? 3 + 7 : 3;
            break;
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.THURSDAY */ .eO.THURSDAY:
            sortNumber = 4 < foundStartDay ? 4 + 7 : 4;
            break;
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.FRIDAY */ .eO.FRIDAY:
            sortNumber = 5 < foundStartDay ? 5 + 7 : 5;
            break;
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.SATURDAY */ .eO.SATURDAY:
            sortNumber = 6 < foundStartDay ? 6 + 7 : 6;
            break;
        default:
            _types__WEBPACK_IMPORTED_MODULE_1__/* .assertUnreachable */ .U(dayOfWeek);
            sortNumber = 1;
            break;
    }
    return sortNumber;
};
/**
 * Convert a `DayOfWeek` enum to a number. We default to Monday (i.e. 1).
 */ var getDayNumberOfEnum = function(dayOfWeek) {
    switch(dayOfWeek){
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.SUNDAY */ .eO.SUNDAY:
            return 0;
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.MONDAY */ .eO.MONDAY:
            return 1;
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.TUESDAY */ .eO.TUESDAY:
            return 2;
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.WEDNESDAY */ .eO.WEDNESDAY:
            return 3;
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.THURSDAY */ .eO.THURSDAY:
            return 4;
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.FRIDAY */ .eO.FRIDAY:
            return 5;
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.SATURDAY */ .eO.SATURDAY:
            return 6;
        default:
            _types__WEBPACK_IMPORTED_MODULE_1__/* .assertUnreachable */ .U(dayOfWeek);
            return 1;
    }
};
/**
 * Convert a schedule shift element into a appointment element needed for the calendar widget.
 *
 * This part gets a little hairy. We need to convert the generic "Monday 8 - 16" into a specific
 * date on the calendar, based on the dates we are shown. Furthermore, these dates can change, depending
 * on the start day of the week that the user has configured.
 *
 * We first figure out if the calendar if the start day of the calendar is after our current date, which
 * will mean that the week view is shifted one week back.
 *
 * Then we take the day of the shift event, e.g. Monday, and subtract the start day, e.g. Tuesday. If
 * this day is lower than 0, we know that we are on a date before the start date, and we need to add 7
 * days to the result of this, because we previously accounted for the shift in the week view.
 *
 * Finally, we can get the dates from the current date + the shift in week view + the shift from start
 * date.
 */ var convertGenericShiftTimeToDatePair = function(timeRange, date, startDay) {
    var from = timeRange.from, to = timeRange.to;
    var dayOfStartDay = getDayNumberOfEnum(startDay);
    var dayOfShiftStart = getDayNumberOfEnum(from.day);
    var dayOfShiftEnd = getDayNumberOfEnum(to.day);
    var currentDayInWeek = date.getDay();
    if (dayOfShiftEnd < dayOfShiftStart) {
        dayOfShiftEnd += 7;
    }
    // If the start day is before the current day of the week, we must shift our days back.
    var shiftToLastWeek = 0;
    if (currentDayInWeek < dayOfStartDay) {
        // We shift it back a week, and then add the days in that week that has already passed.
        shiftToLastWeek = -7 + (dayOfStartDay - currentDayInWeek);
    } else {
        shiftToLastWeek = dayOfStartDay - currentDayInWeek;
    }
    // Shift the day of the shift based on the start day of the schedule.
    var shiftForStartDate = dayOfShiftStart - dayOfStartDay;
    if (shiftForStartDate < 0) {
        // If it's below 0, that's because it wrapped around, so we subtract the shift from 7.
        shiftForStartDate = 7 + shiftForStartDate;
    }
    // Finally, we create a new date from this shift in days.
    var shiftedDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    shiftedDate.setDate(shiftedDate.getDate() + shiftToLastWeek + shiftForStartDate);
    var wrapShift = dayOfShiftEnd < dayOfShiftStart;
    var shiftShift = wrapShift ? dayOfShiftStart - 1 : dayOfShiftEnd - dayOfShiftStart;
    return {
        from: new Date(shiftedDate.getFullYear(), shiftedDate.getMonth(), shiftedDate.getDate(), from.hour, from.minute),
        to: new Date(shiftedDate.getFullYear(), shiftedDate.getMonth(), shiftedDate.getDate() + shiftShift, to.hour, to.minute)
    };
};
/**
 * Convert a shift into an appointment, for use with our DX Scheduler component. An
 * appointment looks something like (as a minimum):
 * ```
{
  title: 'Website Re-Design Plan',
  startDate: new Date(2019, 4, 15, 9, 30),
  endDate: new Date(2019, 4, 15, 11, 30),
  id: 0,
  location: 'Room 1',
}
```
 */ var mkAppointmentsFromShifts = function(shifts, date, startDay) {
    var ref = convertGenericShiftTimeToDatePair({
        from: {
            day: startDay,
            hour: 0,
            minute: 0
        },
        to: {
            day: startDay === generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.SUNDAY */ .eO.SUNDAY ? generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.SATURDAY */ .eO.SATURDAY : generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.SUNDAY */ .eO.SUNDAY,
            hour: 23,
            minute: 59
        }
    }, date, startDay), scheduleStart = ref.from, scheduleEnd = ref.to;
    return shifts.reduce(function(shifts, shift) {
        // All this hackery is necessary because the devexpress framework does not support "appointments" that are longer
        // than `24 hours - 1ms`.
        // Shifts rotate on a week boundary, so we determine the chunks based off of the duration to consume - that is, if
        // the shift spans more than 24 hours, we split it into consecutive chunks.
        var ref = convertGenericShiftTimeToDatePair(shift.timeRange, date, startDay), startDate = ref.from, endDate = ref.to;
        // If DST starts during the span in the following week, make sure we use the end timezone rather than the following
        // week's when we circle back to the beginning.
        var endDateOffset = scheduleEnd.getTime() < endDate.getTime() ? scheduleEnd.getTimezoneOffset() : endDate.getTimezoneOffset();
        // We shift to local time to utilize modulus rings targetting 24 hours. This should also reveal any DST
        // changes. However, we use the calendar boundary if end spans into the following week.
        var shiftedStartDate = new Date(startDate.getTime() - startDate.getTimezoneOffset() * 1..minutes);
        var shiftedEndDate = new Date(endDate.getTime() - endDateOffset * 1..minutes);
        var startSplit = shiftedStartDate.getTime();
        var durationToConsume = shiftedEndDate.getTime() - shiftedStartDate.getTime();
        while(0 < durationToConsume){
            // Subtract one to avoid extending into the following day - it's added back when subtracting the duration.
            var dayEnd = Math.ceil((startSplit + 1) / 24..hours) * 24..hours - 1;
            var startTimeOffset = new Date(startSplit).getTimezoneOffset() * 1..minutes;
            var partStartDate = new Date(startSplit + startTimeOffset);
            var timeTillMidnight = dayEnd - startSplit;
            var partEndDate = new Date(partStartDate.getTime() + Math.min(durationToConsume, timeTillMidnight));
            shifts.push({
                title: shift.name,
                id: shift.id,
                startDate: partStartDate,
                endDate: partEndDate,
                originalShift: shift
            });
            durationToConsume -= partEndDate.getTime() - partStartDate.getTime() + 1;
            // We don't need to shift the scheduleStart, since it's cancelled out after the rotation.
            startSplit = scheduleStart.getTime() + (startSplit - scheduleStart.getTime() + timeTillMidnight + 1) % 7..days;
        }
        return shifts;
    }, []);
};
var ref, ref1;
/**
 * We remap the whole schedule, to avoid all `__typename` fields.
 */ var unrollSchedule = function(schedule) {
    return {
        lineId: schedule === null || schedule === void 0 ? void 0 : schedule.lineId,
        validFrom: {
            year: schedule === null || schedule === void 0 ? void 0 : schedule.validFrom.year,
            week: schedule === null || schedule === void 0 ? void 0 : schedule.validFrom.week
        },
        isExceptionalWeek: (ref = schedule === null || schedule === void 0 ? void 0 : schedule.isExceptionalWeek) !== null && ref !== void 0 ? ref : false,
        shifts: ((ref1 = schedule === null || schedule === void 0 ? void 0 : schedule.shifts) !== null && ref1 !== void 0 ? ref1 : []).map(function(shift) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17;
            return {
                id: shift.id,
                name: shift.name,
                description: shift.description,
                targets: {
                    oee: shift === null || shift === void 0 ? void 0 : (ref = shift.targets) === null || ref === void 0 ? void 0 : ref.oee,
                    oee2: shift === null || shift === void 0 ? void 0 : (ref1 = shift.targets) === null || ref1 === void 0 ? void 0 : ref1.oee2,
                    oee3: shift === null || shift === void 0 ? void 0 : (ref2 = shift.targets) === null || ref2 === void 0 ? void 0 : ref2.oee3,
                    tcu: shift === null || shift === void 0 ? void 0 : (ref3 = shift.targets) === null || ref3 === void 0 ? void 0 : ref3.tcu,
                    produced: shift === null || shift === void 0 ? void 0 : (ref4 = shift.targets) === null || ref4 === void 0 ? void 0 : ref4.produced,
                    numberOfBatches: shift === null || shift === void 0 ? void 0 : (ref5 = shift.targets) === null || ref5 === void 0 ? void 0 : ref5.numberOfBatches
                },
                timeRange: {
                    from: {
                        day: shift === null || shift === void 0 ? void 0 : (ref6 = shift.timeRange) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.from) === null || ref7 === void 0 ? void 0 : ref7.day,
                        hour: shift === null || shift === void 0 ? void 0 : (ref8 = shift.timeRange) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.from) === null || ref9 === void 0 ? void 0 : ref9.hour,
                        minute: shift === null || shift === void 0 ? void 0 : (ref10 = shift.timeRange) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.from) === null || ref11 === void 0 ? void 0 : ref11.minute
                    },
                    to: {
                        day: shift === null || shift === void 0 ? void 0 : (ref12 = shift.timeRange) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.to) === null || ref13 === void 0 ? void 0 : ref13.day,
                        hour: shift === null || shift === void 0 ? void 0 : (ref14 = shift.timeRange) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.to) === null || ref15 === void 0 ? void 0 : ref15.hour,
                        minute: shift === null || shift === void 0 ? void 0 : (ref16 = shift.timeRange) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.to) === null || ref17 === void 0 ? void 0 : ref17.minute
                    }
                }
            };
        })
    };
};
var getShiftFromShifts = function(shifts, date, startDay, options) {
    var target = (options === null || options === void 0 ? void 0 : options.target) || "current";
    // Bipolar offset, i.e.: -1, 0, 1
    var indexOffset = +(target === "previous") || -(target === "next");
    var sortedShifts = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(shifts).sort(function(a, b) {
        var ref = convertGenericShiftTimeToDatePair(a.timeRange, date, startDay), dateA = ref.to;
        var ref1 = convertGenericShiftTimeToDatePair(b.timeRange, date, startDay), dateB = ref1.to;
        return dateA.getTime() - dateB.getTime();
    });
    var restructuredShifts = sortedShifts.map(function(shift) {
        var ref = convertGenericShiftTimeToDatePair(shift.timeRange, date, startDay), startDate = ref.from, endDate = ref.to;
        return {
            shift: shift,
            startDate: startDate,
            endDate: endDate
        };
    });
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(restructuredShifts.slice(restructuredShifts.length - 1), 1), lastShift = ref[0];
    if (!lastShift) {
        return;
    }
    if ((lastShift.endDate.getDay() || 7) < (lastShift.startDate.getDay() || 7)) {
        restructuredShifts.unshift({
            shift: lastShift.shift,
            startDate: (0,date_fns__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(lastShift.startDate, 7),
            endDate: (0,date_fns__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(lastShift.endDate, 7)
        });
    }
    var index = restructuredShifts.reverse().findIndex(function(param) {
        var startDate = param.startDate;
        return startDate <= date;
    });
    return restructuredShifts[index + indexOffset];
};
var getWeekdayNumberSane = function(dayOfWeek) {
    switch(dayOfWeek){
        case "MONDAY":
            return 0;
        case "TUESDAY":
            return 1;
        case "WEDNESDAY":
            return 2;
        case "THURSDAY":
            return 3;
        case "FRIDAY":
            return 4;
        case "SATURDAY":
            return 5;
        case "SUNDAY":
            return 6;
        default:
            return 0;
    }
};
var shiftDuration = function(timeRange) {
    var _from = timeRange.from, fromDayEnum = _from.day, fromHour = _from.hour, fromMinute = _from.minute, _to = timeRange.to, toDayEnum = _to.day, toHour = _to.hour, toMinute = _to.minute;
    // NOTE: Shift it by one day, just to make sure we don't end up at a zero-day
    // (1970-01-00)
    var fromDay = getWeekdayNumberSane(fromDayEnum) + 1;
    var toDay = getWeekdayNumberSane(toDayEnum) + 1;
    if (toDay < fromDay) {
        toDay += 7;
    }
    var fromTimestamp = new Date([
        "1970-01-",
        [
            fromDay,
            fromHour,
            fromMinute
        ].map(function(part) {
            return part.toLocaleString(undefined, {
                minimumIntegerDigits: 2
            });
        }).join(":").replace(":", "T"),
        ":00.000Z", 
    ].join("")).getTime();
    var toTimestamp = new Date([
        "1970-01-",
        [
            toDay,
            toHour,
            toMinute
        ].map(function(part) {
            return part.toLocaleString(undefined, {
                minimumIntegerDigits: 2
            });
        }).join(":").replace(":", "T"),
        ":00.000Z", 
    ].join("")).getTime();
    return toTimestamp - fromTimestamp;
};


/***/ }),

/***/ 90749:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ withDevice; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4656);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86533);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78391);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29901);
/* harmony import */ var _contexts_device__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17294);







var withDevice = function(WrappedComponent) {
    return /*#__PURE__*/ function(_PureComponent) {
        "use strict";
        (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(WithDeviceWrapper, _PureComponent);
        var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(WithDeviceWrapper);
        function WithDeviceWrapper() {
            (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, WithDeviceWrapper);
            return _super.apply(this, arguments);
        }
        var _proto = WithDeviceWrapper.prototype;
        _proto.render = function render() {
            var _this = this;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_contexts_device__WEBPACK_IMPORTED_MODULE_5__/* .DeviceContext.Consumer */ .T.Consumer, {
                children: function(param) {
                    var owner = param.owner, uuid = param.uuid, index = param.index, NodePicker = param.NodePicker, deviceType = param.deviceType, lineNodes = param.lineNodes, deviceLineId = param.deviceLineId;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WrappedComponent, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                        forceLoad: false,
                        owner: owner !== null && owner !== void 0 ? owner : null,
                        uuid: uuid,
                        index: index ? index.toString() : undefined,
                        deviceType: deviceType,
                        peripheralId: "".concat(uuid, "-").concat(index),
                        NodePicker: NodePicker,
                        lineNodes: lineNodes,
                        deviceLineId: deviceLineId
                    }, _this.props));
                }
            });
        };
        return WithDeviceWrapper;
    }(react__WEBPACK_IMPORTED_MODULE_1__.PureComponent);
};


/***/ }),

/***/ 41440:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ withLine; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4656);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86533);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78391);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29901);
/* harmony import */ var _contexts_line__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89506);







// tslint:disable:max-classes-per-file
var withLine = function(WrappedComponent) {
    return /*#__PURE__*/ function(_PureComponent) {
        "use strict";
        (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(WithLineWrapper, _PureComponent);
        var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(WithLineWrapper);
        function WithLineWrapper() {
            (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, WithLineWrapper);
            return _super.apply(this, arguments);
        }
        var _proto = WithLineWrapper.prototype;
        _proto.render = function render() {
            var _this = this;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_contexts_line__WEBPACK_IMPORTED_MODULE_5__/* .LineContext.Consumer */ .t.Consumer, {
                children: function(param) {
                    var lineId = param.lineId, lineName = param.lineName;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WrappedComponent, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                        lineId: lineId,
                        lineName: lineName
                    }, _this.props));
                }
            });
        };
        return WithLineWrapper;
    }(react__WEBPACK_IMPORTED_MODULE_1__.PureComponent);
};


/***/ }),

/***/ 81861:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ withUtils; },
/* harmony export */   "n": function() { return /* binding */ useUtils; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93089);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var _date_io_date_fns__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14478);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54765);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18151);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(28879);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(84984);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(83558);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(68568);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(84358);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29901);
/* harmony import */ var _locale__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(36712);







var additionalUtils = function(locale) {
    return {
        formatDistance: function(date, baseDate) {
            var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            return (0,date_fns__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(date, baseDate, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, options), {
                locale: locale
            }));
        },
        formatDistanceStrict: function(date, baseDate) {
            var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            return (0,date_fns__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(date, baseDate, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, options), {
                locale: locale
            }));
        },
        formatRelative: function(date, baseDate) {
            var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            return (0,date_fns__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(date, baseDate, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, options), {
                locale: locale
            }));
        },
        formatWeekdays: function(formatString) {
            var now = new Date();
            return (0,date_fns__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                start: (0,date_fns__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(now, {
                    locale: locale,
                    weekStartsOn: 0
                }),
                end: (0,date_fns__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(now, {
                    locale: locale,
                    weekStartsOn: 0
                })
            }).map(function(day) {
                return (0,date_fns__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(day, formatString, {
                    locale: locale
                });
            });
        }
    };
};
var useUtils = function() {
    var utils = new _date_io_date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z();
    return Object.assign(utils, additionalUtils((utils === null || utils === void 0 ? void 0 : utils.locale) || (0,_locale__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)("enUS")));
};
var withUtils = function(WrappedComponent) {
    return function(props) {
        var utils = useUtils();
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WrappedComponent, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props), {
            utils: Object.assign(utils, additionalUtils((utils === null || utils === void 0 ? void 0 : utils.locale) || (0,_locale__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)("enUS")))
        }));
    };
};


/***/ })

}]);